/// <reference path="../assets.d.ts" />
import { Asset } from 'expo-asset';
import type { ImageSource } from '../image.types';
import debugResolutionsAsset from './debug-resolutions.webp';

// Web variant. The bundled WebP's URL, which the image layer fetches.
export const debugResolutions: ImageSource = Asset.fromModule(debugResolutionsAsset).uri;
